module.exports = __webpack_public_path__ + "static/alpha_telegram_art@2x-258efcbc712f15ea7d20eed6df545f27.png";